/**
 * 取当前 url，取 hash
 * 
 */

var tpl = require('./menu_module_tpl.html');
var _  = require('lodash');
var handle = _.template(tpl, {variable: 'data'});

var url_util = require('../../../url_util/url_util.js');
var location_object = url_util.initByUrlString(window._qiwa.page_global.nav_highlight_url);

// 本地测试应当作为测试环境
if (location_object.hostname === '127.0.0.1') {
	location_object.hostname = 'devtest.souche.com';
	location_object.host = 'devtest.souche.com';
}

var submemu_module = require('./modules/submenu_module.js');
var sys_global = require('../../../qiwa-static/sys_global.js');

var _store = {
	$dom: $('<div>'),
	$html: false,
	$q_service: $.when(false)
};

var _service = {
	icon: ['icon-shouye', 'icon-maiche', 'icon-maiche2', 'icon-fuwu', 'icon-shangdian'],
	// 首页可能的 url
	index: ['/', '/index.htm', '/index.html']
}

var _control = {
	init: function () {
		var that = this;
		return _store.$q_service.then(function (data) {
			var show_menu = false;
			if (data) {
				var location_pathname_is_index = false;
				$.each(_service.index, function (ii, vv) {
					if (location_object.pathname == vv) {
						location_pathname_is_index = true;
					};
				});
				$.each(data.menu, function (i, v) {
					// v.metaType
					// * 0: 页面
					// * 7: 文章
					// * 8: 外链
					
					v._icon = _service.icon[i];
					
					// 如果菜单已显示，不再判断后面的菜单
					if (show_menu) {
						return true;
					}

					if (v.url.indexOf('http://') !== 0 && v.url.indexOf('https://') !== 0 && v.url.indexOf('/') !== 0) {
						v.url = '//' + v.url;
					}
					
					var url_object = url_util.initByUrlString(v.url);

					// 不是外链，使用当前域名
					if (v.metaType != 8) {
						url_object.host = location_object.host;
						url_object.hostname = location_object.hostname;
						url_object.origin = location_object.origin;
					}

					v.url = url_object
						.s('edit', location_object.search.get('edit'))
						.s('__mobile', location_object.search.get('__mobile'))
						.toString();

					var url_pathname_is_index = false;
					$.each(_service.index, function (ii, vv) {
						if (url_object.pathname == vv) {
							url_pathname_is_index = true;
						}
					});
					var is_index = location_pathname_is_index && url_pathname_is_index;
					
					if (v.metaType == 8 && location_object.host != url_object.host) {
						// 不做任何操作
					} else if (location_object.pathname == '/webpage.htm') {
						if (url_object.pathname == '/webpage.htm' 
							&& location_object.search.get('pageId') == url_object.search.get('pageId')) {
							show_menu = true;
							v._active = true;
						}
					} else {
						if (location_object.pathname == url_object.pathname || is_index) {
							show_menu = true;
							v._active = true;
						}
					}
				});
			}
			if (!show_menu) {
				return false;
			} else {
				return data;
			}
		}).then(function (data) {
			if (data) {
				var html = handle({
					menu: data.menu,
					submenuInfo: data.submenuInfo,
					menu_length: data.submenu? 5: data.menu.length,
					baseColor: (function () {
						return sys_global.__site_basic
							&& sys_global.__site_basic.h5BaseColor
							|| sys_global.__site_basic.color
					})()
				});
				that.bind(html);
			}
		}).then(function () {
			return _store.$dom;
		});
	},
	bind: function (html) {
		_store.$html = $(html).appendTo(_store.$dom);
		$('body').addClass('padding-bottom-50px');
		$('body').append(submemu_module.init(_store.$q_service.then(function (data) {
			return data;
		})).$dom);

		_store.$html.on('click', '.navigation-item--show-submodule', function(event) {
			event.preventDefault();
			/* Act on the event */
			submemu_module.do(function (url) {
				window.location.href = url;
			});
		});
	}
}

module.exports = {
	init: function ($q_service) {
		_store.$q_service = $q_service;
		return _control.init();
	}
}



//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/qiwa-common_m/modules_m/menu_module/menu_module.js
// module id = 280
// module chunks = 4